import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {delay, map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {SharedService} from '../../../../../../../core/services/store/shared-store/shared-storage.service';
import {environment} from '../../../../../../../../environments/environment';

interface AiAssistants {
    'assistant_name_friendly': string;
    'assistant_uuid': string;
    'assistant_type_id': number;
}

export interface AiAssistantIds {
    'name': string;
    'assistantId': string;
}

@Injectable({
    providedIn: 'root'
})
export class AiAssistantService {

    constructor(
        private http: HttpClient,
        private sharedService: SharedService
    ) {
    }

    getAiAssistants(): Observable<AiAssistantIds[]> {

        const url = `${environment.controlBaseUrl}/ai/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}/assistants`;

        return this.http.get<AiAssistants[]>(url, {
            withCredentials: true
        })
            .pipe(
                map((assistants: AiAssistants[]) =>
                    assistants.map(assistant => ({
                        name: assistant.assistant_name_friendly,
                        assistantId: assistant.assistant_uuid
                    }))
                )
            );

    }
}
